import { logger } from '@app/common/logger/logger'

import AuthAction from './actions'
import { readAuthSessionRecord } from './authSessionRecord'
import { AuthStore, LogoutReason } from './models'

const logoutBecauseAnotherTabEndedTheSession = (store: AuthStore): void => {
  const { id, refreshToken } = store.getState().auth

  logger.info(
    `another tab ended the session of lawyer ${id}, logging out refreshToken ${refreshToken?.slice(
      -4
    )}`
  )

  store.dispatch(AuthAction.logout(LogoutReason.ANOTHER_TAB_ENDED_THE_SESSION))
}

export const adoptEndedAuthSession = (store: AuthStore): void => {
  const { token, refreshToken } = store.getState().auth

  if (!token && !refreshToken) {
    return
  }

  logoutBecauseAnotherTabEndedTheSession(store)
}

export const syncAuthSession = (store: AuthStore): void => {
  const { id, refreshToken } = store.getState().auth
  const recordedSession = readAuthSessionRecord()

  if (!recordedSession) {
    if (refreshToken) {
      logoutBecauseAnotherTabEndedTheSession(store)
    }

    return
  }

  if (recordedSession.refreshToken === refreshToken) {
    return
  }

  logger.info(
    `syncAuthSession of lawyer ${id}: adopting recorded refreshToken ${recordedSession.refreshToken.slice(
      -4
    )} over in-memory refreshToken ${refreshToken?.slice(-4)}`
  )

  store.dispatch(AuthAction.onRefreshSuccess(recordedSession))
}
